
import { Placement } from '@post-office/placements-frontend/wiv-beta-changeboarding';
export default Placement;
